export const summary = (l10n={}, it = {}, data = {}) => {
    const { image, gradeId, name, favorite, id, maxGrowthLevel = 0 } = it;
    const { isSkinType = false, buffcardGrowthLevel = 0, defaultThumb } = data;
    
    // make 'buffcard growth level options' template
    let growthLevelOptionsTmpl = '';
    for (let i = 0; i <= maxGrowthLevel; i++) {
        growthLevelOptionsTmpl += `<li data-detailshow="polymorph_${id}_${i}" data-buff="${i}">+${i}</li>`;
    }

    return `
    <section class="summary">
        <img class="thumb" src="${image}" onerror="this.src='${defaultThumb}';">

        ${!maxGrowthLevel ? `` : `
        <div class="ui-dropdown-wrap buffcard">
            <div class="ui-dropdown ui-dropdown-community">
                <div class="select">
                    <span class="selectedCategory" data-value="">+${buffcardGrowthLevel}</span>
                </div>
                <div class="option">
                    <div class="option-menu" style="width: 100%;">
                        <ul class="option-list">${growthLevelOptionsTmpl}</ul>
                    </div>
                </div>
            </div>
        </div>
        `}

        <div class="spec">
            <strong class="name" data-itemgrade="${gradeId}">${name}</strong>
            <div class="ability">
                ${isSkinType?`
                    <span class="value" title="${l10n['transformation.morphskin']}">${l10n['transformation.morphskin']}</span>
                `:`
                    <span class="value" title="${l10n['transformation.transformation']}">${l10n['transformation.transformation']}</span>
                `}
            </div>
        </div>
        <button class="btn-favorite${favorite?' is-active':''}" data-info="polymorphs_${id}"><i></i> Favorite</button>
    </section>`;
}
